import { Component, inject } from '@angular/core';

import { FeedbackService } from '../services/feedback.service';
import { ToastComponent } from '../shared/toast/toast.component';
import { Feedback } from '../shared/models/feedback.model';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  standalone: false
})
export class FeedbackComponent {
  toast = inject(ToastComponent);
  private feedbackService = inject(FeedbackService);


  feedback = '';
  currentContent = 'feedback';
  menuItems = [
    { name: 'Send feedback', link: 'feedback', icon: 'commenting' }
  ];

  addFeedback(): void {
    const params: Feedback = {
      feedback: this.feedback
    };
    this.feedbackService.add(params)
      .pipe(finalize(() => this.feedback = ''))
      .subscribe({
        next: res => this.toast.setMessage('Feedback sent, thank you!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
